import { Box, Typography } from '@cmg/design-system';
import React from 'react';

import { RevisionType } from './hooks/useGetRevisionType';

export type Props = Readonly<{
  revisionType: RevisionType;
  investorName: string;
  isSellSideIndicationVersion: boolean;
}>;

const UpdateDetailContentText: React.FC<Props> = ({
  revisionType,
  investorName,
  isSellSideIndicationVersion,
}) => {
  return (
    <Box p={2} pb={0} data-testid="cancel-pass-message">
      {revisionType === RevisionType.Cancelled &&
        (isSellSideIndicationVersion ? (
          <Typography>
            {investorName} has <b>cancelled</b> their indication for this offering.
          </Typography>
        ) : (
          <Typography>
            The indication for this offering has been <b>cancelled</b>.
          </Typography>
        ))}
      {revisionType === RevisionType.Deleted && (
        <Typography>
          {investorName} has been <b>deleted</b> for this offering.
        </Typography>
      )}
      {revisionType === RevisionType.Passed && (
        <Typography>
          {investorName} has submitted a <b>pass</b> for this offering.
        </Typography>
      )}
    </Box>
  );
};

export default UpdateDetailContentText;
